/**
 * HIPAA-Compliant Password Validation Utility
 * 
 * Rules:
 * 1. Length: 8-64 characters
 * 2. Complexity: 1 Upper, 1 Lower, 1 Number, 1 Special Char (!@#$%^&*)
 * 3. disallow common weak passwords
 */

const COMMON_PASSWORDS = [
    '12345678',
    'password',
    'qwerty',
    'patient123',
    '123456',
    '123456789',
    '1234567890',
    'admin',
    'welcome',
    'admin123'
];

export const validatePassword = (password, userData = {}) => {
    if (!password) {
        return { isValid: false, error: 'Password is required.' };
    }

    // 1. Length Check
    if (password.length < 8) {
        return { isValid: false, error: 'Password must be at least 8 characters long.' };
    }
    if (password.length > 64) {
        return { isValid: false, error: 'Password must be less than 64 characters.' };
    }

    // 2. Common Passwords Check
    if (COMMON_PASSWORDS.includes(password.toLowerCase())) {
        return { isValid: false, error: 'This password is too common and cannot be used.' };
    }

    // 3. Complexity Check
    const hasUpperCase = /[A-Z]/.test(password);
    const hasLowerCase = /[a-z]/.test(password);
    const hasNumber = /[0-9]/.test(password);
    const hasSpecialChar = /[!@#$%^&*]/.test(password);

    if (!hasUpperCase) {
        return { isValid: false, error: 'Password must contain at least one uppercase letter.' };
    }
    if (!hasLowerCase) {
        return { isValid: false, error: 'Password must contain at least one lowercase letter.' };
    }
    if (!hasNumber) {
        return { isValid: false, error: 'Password must contain at least one number.' };
    }
    if (!hasSpecialChar) {
        return { isValid: false, error: 'Password must contain at least one special character (!@#$%^&*).' };
    }

    // 4. User Data Check (Name/Birthdate)
    if (userData.firstName && password.toLowerCase().includes(userData.firstName.toLowerCase())) {
        return { isValid: false, error: 'Password cannot contain your first name.' };
    }
    if (userData.lastName && password.toLowerCase().includes(userData.lastName.toLowerCase())) {
        return { isValid: false, error: 'Password cannot contain your last name.' };
    }
    if (userData.dob && password.includes(userData.dob)) { // Simple string check, format dependent
        return { isValid: false, error: 'Password cannot contain your birth date.' };
    }

    return { isValid: true, error: null };
};
